import { featuredItems } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function FeaturedGallery() {
  return (
    <section id="featured" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <span className="text-xs font-label tracking-widest text-primary-600 uppercase">Featured Collections</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">精选合集</h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700 max-w-2xl">
                从全部整理内容中挑出的六组主题，兼顾写真、自拍、旅拍与壁纸方向，每组都有相对统一的用光与配色，适合作为浏览起点。
              </p>
            </div>
            <a
              href="#categories"
              className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              查看全部主题
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <article className="group h-full rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors">
                <div className="relative w-full h-52 md:h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title}主题合集封面`}
                    title={`${item.title} · 年轻的岳母图片合集`}
                    className="w-full h-full object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-[11px] font-medium text-foreground-800">
                    {item.tag}
                  </span>
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-[11px] font-medium text-background-50">
                    {item.count}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}